// Animated cinematic background — softly drifting gradient orbs.
// Decorative, so aria-hidden.
//
// `variant`:
//   - "noir"  — dark hero (high-contrast pink + gold orbs)
//   - "ivory" — light hero (softer, lower-saturation orbs that read on cream)
export function Aurora({ variant = "noir" }) {
  const isDark = variant === "noir";
  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        overflow: "hidden",
        zIndex: 0,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "-25%",
          left: "-20%",
          width: "75vmax",
          height: "75vmax",
          borderRadius: "50%",
          background: isDark
            ? "radial-gradient(circle, rgba(196, 135, 154, 0.22), transparent 70%)"
            : "radial-gradient(circle, rgba(196, 135, 154, 0.18), transparent 70%)",
          filter: "blur(60px)",
          animation: "auroraDrift 22s ease-in-out infinite",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-25%",
          right: "-20%",
          width: "70vmax",
          height: "70vmax",
          borderRadius: "50%",
          background: isDark
            ? "radial-gradient(circle, rgba(201, 168, 76, 0.14), transparent 70%)"
            : "radial-gradient(circle, rgba(201, 168, 76, 0.12), transparent 70%)",
          filter: "blur(60px)",
          animation: "auroraDrift 28s ease-in-out infinite reverse",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "30%",
          right: "30%",
          width: "40vmax",
          height: "40vmax",
          borderRadius: "50%",
          background: isDark
            ? "radial-gradient(circle, rgba(232, 180, 184, 0.08), transparent 70%)"
            : "radial-gradient(circle, rgba(232, 180, 184, 0.18), transparent 70%)",
          filter: "blur(80px)",
          animation: "auroraDrift 32s ease-in-out infinite",
        }}
      />
    </div>
  );
}
